// DEPRECATED
export default function test(a) {
    if (a === undefined || a === null) return "Field is required";
    return true;
}
